import { useCoreGameStatesStore } from '@/services/coreGameStates';

const labels = { stopped: 'Inactive', connecting: 'Connecting', baseline: 'Establishing baseline',
  live: 'Connected', disconnected: 'Disconnected' };
const eventLabels = { record: 'Invalid selected records', 'provider-reports': 'Invalid provider reports',
  connection: 'Connection interrupted' };

/** Passive observer: visiting Health must not open a feed or request a snapshot. */
export function GameStateHealth() {
  const { configured, status, error, diagnostics } = useCoreGameStatesStore();
  return (
    <section className="border-border min-w-0 rounded-lg border p-4" aria-label="Game-state comparison diagnostics">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 className="text-sm font-semibold">Game-state comparisons</h2>
        <span className="text-xs">{configured ? labels[status] : 'Not configured'}</span>
      </div>
      <p className="text-muted-foreground mt-1 text-xs">
        This tab only. Comparisons do not control primary scores or trading. History lasts until sign-out,
        account/organization/role change, or page reload. Opening Health does not start a feed.
      </p>
      {!configured ? <p className="mt-2 text-xs">Existing primary score feeds remain in use.</p> : <>
        {status === 'stopped' && <p className="mt-2 text-xs">No active comparison reader. Retained history is not current feed health.</p>}
        {error && <p className="mt-2 break-words text-xs text-amber-400">{error}</p>}
        <p className="mt-2 text-xs">Retained records: {diagnostics.invalidRecords} invalid selected records;
          {' '}{diagnostics.invalidReports} invalid provider reports.
          {status !== 'live' && ' The comparison feed is not connected.'}</p>
        {diagnostics.lastObservedAtMs !== null && <p className="text-muted-foreground mt-1 break-words text-xs">
          Last connected observation: <time dateTime={new Date(diagnostics.lastObservedAtMs).toISOString()}>
            {new Date(diagnostics.lastObservedAtMs).toISOString()}</time>. This is an observation time, not source freshness.
        </p>}
      </>}
      <h3 className="mt-3 text-xs font-semibold">Recent diagnostics (up to 20)</h3>
      {diagnostics.events.length === 0 ? <p className="text-muted-foreground mt-1 text-xs">No incidents observed in this session.</p> :
        <ol className="mt-1 max-h-60 space-y-1 overflow-y-auto text-xs" aria-label="Recent game-state diagnostics" tabIndex={0}>
          {[...diagnostics.events].reverse().map((event, i) => <li key={i} className="flex flex-wrap gap-x-3 gap-y-1 border-b border-border/50 py-1">
            <time className="break-all font-mono" dateTime={new Date(event.atMs).toISOString()}>{new Date(event.atMs).toISOString()}</time>
            <span>{eventLabels[event.kind]}: {event.count}</span>
          </li>)}
        </ol>}
    </section>
  );
}
